// src/pages/AuthPage/AuthPage.jsx
import React from "react";
import { signInWithGoogle } from "services/auth";
import AuthLayout from "layouts/AuthLayout/AuthLayout";
import { Button } from "components/ui/button";
import logoEmpresa from "assets/images/Logo timbo transparente colorido.png";
import toast from "react-hot-toast";

function AuthPage() {
  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Falha no login com Google:", error);
      toast.error("Falha no login. Tente novamente.");
    }
  };

  return (
    <AuthLayout>
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="w-full max-w-sm bg-white p-8 rounded-lg shadow-xl text-center">
          <img
            src={logoEmpresa}
            alt="Logo da Empresa"
            className="w-32 h-auto mx-auto mb-8"
          />
          <h1 className="text-2xl font-bold mb-2 text-gray-800">
            Sistema de Gerenciamento
          </h1>
          <p className="text-gray-600 mb-8">Faça login para continuar</p>
          <Button onClick={handleGoogleSignIn} className="w-full" size="lg">
            Entrar com Google
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
}

export default AuthPage;
